import { SvgIconComponent } from '@mui/icons-material'
import InfoOutlined from '@mui/icons-material/InfoOutlined'
import { IconOwnProps, IconProps, SxProps, Theme, Tooltip } from '@mui/material'
import { FC, ReactNode } from 'react'

export type LoadedTooltipProps = {
  message: ReactNode
  size?: 'small' | 'large'
  Icon?: SvgIconComponent
  iconProps?: IconProps
  color?: 'primary' | 'secondary' | 'success' | 'action' | 'disabled'
  tooltipSxProps?: SxProps<Theme>
  arrow?: boolean
  placement?:
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top'
}

/**
 * Renders the given icon with a tooltip on it with the given message and position.
 * @param param0
 * @returns
 */
const LoadedTooltip: FC<LoadedTooltipProps> = ({
  message,
  size,
  color = 'disabled',
  tooltipSxProps,
  arrow = true,
  placement,
  Icon = InfoOutlined,
  iconProps,
}) => {
  return (
    <Tooltip
      title={message}
      sx={tooltipSxProps}
      arrow={arrow}
      placement={placement}
    >
      <Icon
        fontSize={size}
        sx={{
          ...iconProps?.sx,
          cursor: 'help',
        }}
        color={color}
        className={'LoadedIcon-with-tooltip'}
        {...(iconProps as IconOwnProps)}
      />
    </Tooltip>
  )
}

export default LoadedTooltip
